export default __webpack_public_path__ + "static/media/arrow.7883b97c.svg";